// extracted by mini-css-extract-plugin
export default {"container":"FileUploader_container__pbyuB","title":"FileUploader_title__6Zk88","wrapper":"FileUploader_wrapper__zG3rF","file_detail":"FileUploader_file_detail__12JqS"};